/*
 * Projekt: app.i-gb.de
 * Datei: page.js
 * Author: Thilo Schmidt, info@thiloschmidt.com
 * Copyright (c) 2018, Thilo Schmidt
 * Letzte Änderung: 02.08.18 09:24
 *
 * Kommerzielle Lizenz. Dies ist keine freie Software. Weitergabe, Vervielfältigung oder Kopie des Quellcodes, auch nur auszugsweise, bedarf der Zustimmung des Authors.
 *
 * @category thiloschmidt.com
 * @package app.i-gb.de
 * @author Thilo Schmidt, info@thiloschmidt.com
 * @license  Commercial License https://www.thiloschmidt.com
 * @link https://www.thiloschmidt.com
 */

var app;
const applicationServerPublicKey =
  'BJrCmBicb8b8lizkoyXDIuBIHlzuWbn12wav0Luq6_5yzRyf0Mxq_qEFI7AT4j8GWK2iS2Acmw2gt2dfb217ya4';
var swRegistration = null;
var pushCallback = '';

const callObjectFunctions = (obj) => {
    const allowedFunctions = {
        antwortRichtig: (...args) => antwortRichtig(...args),
        'app.setAppIconBadgeNumber': (...args) => app.setAppIconBadgeNumber(...args),
        demarkall: (...args) => demarkall(...args),
        einausblenden: (...args) => einausblenden(...args),
        initPush: (...args) => initPush(...args),
        marknull: (...args) => marknull(...args),
        mindestDauerStreckeLesen: (...args) => mindestDauerStreckeLesen(...args),
        mitgliederinit: (...args) => mitgliederinit(...args),
        mitgliederzufuegen: (...args) => mitgliederzufuegen(...args),
        punktevergabeinit: (...args) => punktevergabeinit(...args),
        scrolltop: (...args) => scrolltop(...args),
        setstartdate: (...args) => setstartdate(...args),
    };

    if (!obj.callfunc) {
        return;
    }

    $.each(obj.callfunc, (funcname, inhalt) => {
        const fn = allowedFunctions[funcname];
        if (fn && typeof inhalt === 'string') {
          const args = inhalt.split(',').map((s) => s.trim());
          fn(...args);
        }
    });
}

(function () {
  'use strict';

  app = {
    isLoading: true,
    spinner: $('.loader'),
    menustatus: 'c',
    debug: 1,
    dataCacheName: 'igbData-v3',
    homeurl: location.protocol + '//' + location.hostname,
    iososxWebsitePushId: location.hostname,
  };

  if (app.isLoading) {
    app.spinner.hide();
    $('#appModal').modal({
      focus: false,
      show: false,
      backdrop: true,
      keyboard: true,
    });
    $('#appModalNC').modal({
      focus: false,
      show: false,
      backdrop: 'static',
      keyboard: false,
    });
    //app.container.show();
    app.isLoading = false;
  }

  $('#btnmenu').click(function (event) {
    event.stopPropagation();
    if (app.menustatus === 'c') {
      app.menuopen();
      window.scrollTo(0, 0);
    } else {
      app.menuclose();
    }
  });

  $('body').click(function (event) {
    //Hide the menus if visible
    if (app.menustatus === 'o') {
      app.menuclose();
    }
  });

  app.init = function () {
    // prüfe ob localStorage vorhanden und einsatzbereit
    if (storageAvailable('localStorage')) {
      // Noch keine Parameter im localStorage, dann anlegen
      app.log('LSapptoken' + localStorage.getItem('apptoken'), 1);
      if (!localStorage.getItem('apptoken')) {
        app.log('LSapptoken nicht vorhanden', 1);
        app.lokalenSpeicherLoeschen();
        localStorage.setItem('ersterstart', '1');
      }
      if (!localStorage.getItem('history')) {
        app.historyDelete();
      }

      if (localStorage.getItem('apptoken') !== '') {
        if (typeof GET['vp'] !== 'undefined') {
          app.urlparamsAuswerten(GET);
        } else {
          // letzte besuchte Seite anzeigen
          var lastPage = localStorage.getItem('lastpage');
          if (lastPage == 'navi') {
            lastPage = 'start';
          }
          if (lastPage != null && lastPage !== '') {
            var c = lastPage.indexOf('?');
            if (c >= 0) {
              var page = lastPage.substr(0, c);
              var formparam = lastPage.substr(c + 1);
              app.loadPage(page, formparam);
            } else {
              app.loadPage(lastPage);
            }
            app.loadNavi();
          } else {
            app.loadPage('start');
          }
        }
      }
      // Wenn eine Portaltoken übergeben wurde, dann zu checkPortalToken
      else if (typeof GET['t'] !== 'undefined') {
        app.checkPortalToken(GET['t']);
      } else if (typeof GET['vp'] !== 'undefined') {
        app.urlparamsAuswerten(GET);
      } else {
        // Login
        $('#btnmenu').hide();
        if (localStorage.getItem('ersterstart') === '1') {
          app.loadPage('start');
        } else {
          app.loadPage('loginform');
        }
      }
      // Wenn kein Token vorhanden und kein Portaltoken übergeben wurde, dann zum Login oder zum Start
      /*else if (typeof (GET['aba']) !== 'undefined') { // Mail abmelden
                $('#btnmenu').hide();
                app.log('aktionmailabbestellen id=' + GET['aba'], 1);
                app.loadPage('aktionmailabbestellen', 'aba=' + GET['aba'] + '&mid=' + GET['mid']);
            }
            else if (typeof (GET['pz']) !== 'undefined' && typeof (GET['wm']) !== 'undefined' && typeof (GET['ma']) !== 'undefined') { // Passwort estmalig setzen
                app.log('passwortsetzen pz=' + GET['pz'] + '&g=' + GET['g'] + '&wm=' + GET['wm'] + '&ma=' + GET['ma'], 1);
                app.loadPage('passwortsetzen', 'pz=' + GET['pz'] + '&g=' + GET['g'] + '&wm=' + GET['wm'] + '&ma=' + GET['ma'] + '&uebersicht=' + GET['uebersicht']);
                //app.loadNavi();
            }
            else if (typeof (GET['pz']) !== 'undefined') { // Passwort neu setzen
                app.log('passwortneu pz=' + GET['pz'] + '&g=' + GET['g'], 1);
                app.loadPage('passwortneu', 'pz=' + GET['pz'] + '&g=' + GET['g']);
            }*/
      /*if (typeof (GET['p']) !== 'undefined') { // eine Postfachnachricht wurde übergeben, dann direkt dort hin springen
                app.log('postfachdetail id=' + parseInt(GET['p']), 1);
                app.loadPage('postfachdetail', 'id=' + parseInt(GET['p']) + '&t=B');
                app.loadNavi();
            }
            else if (typeof (GET['vp']) !== 'undefined' && GET['vp'] !== '') { // Page anzeigen
                app.log('vp=' + GET['vp'], 1);
                app.loadPage(GET['vp']);
            }*/
    } else {
      // Too bad, no localStorage for us TODO
    }

    app.menuclose();

    window.addEventListener('popstate', function (event) {
      // alert('back is clicked');
      //app.log(event, 1);
      if (event.state) {
        return app.historyBack();
      }
    });
  };

  app.historyDelete = function (page) {
    var history = [];
    localStorage.setItem('history', JSON.stringify(history));
  };

  app.historyAdd = function (loadedpage) {
    if (loadedpage !== 'loginform') {
      var history = JSON.parse(localStorage.getItem('history'));
      if (history[history.length - 1] !== loadedpage) {
        history.push(loadedpage);
        if (history.length > 50) {
          history.shift();
        }
        localStorage.setItem('history', JSON.stringify(history));
        window.history.pushState({ noBackExitsApp: true }, '');
      }
    }
  };

  app.historyBack = function () {
    if (!localStorage.getItem('history')) {
      return false;
    }
    var history = JSON.parse(localStorage.getItem('history'));
    if (history.length <= 1) {
      //var erg = confirm('Möchten Sie die i-gb APP wirklich verlassen?');
      //if (erg) {
      //    return true;
      //}
      //else {
      return true;
      //}
    }
    var lastPage = history.pop();
    lastPage = history.pop();
    app.log(lastPage, 1);
    localStorage.setItem('history', JSON.stringify(history));
    if (lastPage != null && lastPage !== '') {
      var c = lastPage.indexOf('?');
      if (c >= 0) {
        var page = lastPage.substr(0, c);
        var formparam = lastPage.substr(c + 1);
        app.loadPage(page, formparam);
      } else {
        app.loadPage(lastPage);
      }

      return false;
    }
  };

  app.lokalenSpeicherLoeschen = function () {
    localStorage.setItem('idmitarbeiter', '');
    localStorage.setItem('apptoken', '');
    localStorage.setItem('lastpage', '');
    if (!localStorage.getItem('ersterstart')) {
      localStorage.setItem('ersterstart', '0');
    }
    localStorage.setItem('pushsystem', '-');
    localStorage.setItem('pushnotification', -1);
    app.historyDelete();
    //localStorage.clear();
  };

  app.checkLoginform = function () {
    var url = 'api/checklogin_nc.php';
    var params = {
      login: $('input[name=login]').val(),
      pw: $('input[name=pw]').val(),
    };
    var firma = $('input[name=firma]').val();
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
        'X-Csrf-Token': csrfToken,
      },
    })
      .then(function (response) {
        if (response.ok) {
          return response.json(); // Antwort in JSON wandeln
        }
      })
      .then(function (data) {
        app.log(data, 2);
        if (data && data.status === 'OK') {
          localStorage.setItem('idmitarbeiter', data.idmitarbeiter);
          localStorage.setItem('apptoken', data.apptoken);
          localStorage.setItem(
            'ersterstart',
            data.startseq !== 'undefined' ? data.startseq : '1',
          );

          app.pushmanagerCheck();

          if (firma === 'landingpage') {
            //Die Stadt Kitzingen soll nach dem PW-setzen auf die Nutzung des Angebots kommen - Kai
            app.loadPage('nutzungallg');
          } else {
            var vp = '';
            if (localStorage.getItem('viewpage') !== null) {
              vp = localStorage.getItem('viewpage');
              localStorage.removeItem('viewpage');
            }
            if (vp !== '') {
              app.loadPage(vp);
            } else if (localStorage.getItem('ersterstart') === '1') {
              app.loadPage('profil');
            } else {
              app.loadPage('start');
            }
          }
        } else {
          $('#loginerror').html(data.info);

            if (data.csrfToken) {
                csrfToken = data.csrfToken;
            }
        }
      })
      ['catch'](function (reason) {
        app.log(reason, 1);
      });
  };

  app.checkPortalToken = function (portaltoken) {
    var url = 'api/checktoken_nc.php';
    var params = { portaltoken: portaltoken };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
        'X-Csrf-Token': csrfToken,
      },
    })
      .then(function (response) {
        if (response.ok) {
          return response.json(); // Antwort in JSON wandeln
        }
      })
      .then(function (data) {
        // data = return vom then davor
        app.log(data, 2);
        if (data && data.status === 'OK') {
          localStorage.setItem('idmitarbeiter', data.idmitarbeiter);
          localStorage.setItem('apptoken', data.apptoken);
          localStorage.setItem(
            'ersterstart',
            data.startseq !== 'undefined' ? data.startseq : '1',
          );

          app.pushmanagerCheck();

          if (localStorage.getItem('ersterstart') === '1') {
            app.loadPage('profil');
          } else {
            app.loadPage('start');
          }

          top.location.href = 'index.php';
        } else {
          $('#loginerror').html(data.info);
        }
      })
      ['catch'](function (reason) {
        app.log(reason, 1);
      });
  };

  app.abmelden = function () {
    var url = 'api/abmelden_nc.php';
    var params = {
      idma: localStorage.getItem('idmitarbeiter'),
      token: localStorage.getItem('apptoken'),
    };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
        'X-Csrf-Token': csrfToken,
      },
    })
      .then(function (response) {
        if (response.ok) {
          return response.json(); // Antwort in JSON wandeln
        }
      })
      .then(function (data) {
        // data = return vom then davor
        app.log(data, 2);
        if (data && data.status === 'OK') {
          app.lokalenSpeicherLoeschen();
          app.log(app.dataCacheName, 1);
          //caches.delete(dataCacheName).then(function() {
          top.location.href = location.protocol + '//' + location.hostname; //'https://app.i-gb.de';
          //});
        } else {
          $('#loginerror').html(data.info);
        }
      })
      ['catch'](function (reason) {
        app.log(reason, 1);
      });
  };

  app.menuopen = function () {
    $('#menu').animate({ left: '0px' }, 'fast');
    app.menustatus = 'o';
  };
  app.menuclose = function () {
    $('#menu').animate({ left: '-500px' }, 'fast');
    app.menustatus = 'c';
  };

  app.loadPage = function (page, formparam) {
    app.menuclose();

    if (page == null || page === '') {
      return;
    }

    app.spinner.show();

    var params =
      '&idma=' +
      localStorage.getItem('idmitarbeiter') +
      '&token=' +
      localStorage.getItem('apptoken');
    var url = 'api/page.php?' + encodeURI('page=' + page + params);

    let method = 'GET';
    let headers = {
        'Content-Type': 'application/json',
    };
    if (formparam != null) {
      url += '&' + encodeURI(formparam);
      method = 'POST';
      headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'xmlhttprequest',
        'X-Csrf-Token': csrfToken,
      };
    }

    // Daten vom Server holen wenn möglich, wenn nicht dann schauen ob im Cache vorhanden ist
    fetch(url, {
      method: method,
      headers: headers,
    })
      .then(function (response) {
        app.log('loadPage ' + response, 1);
        if (response.ok) {
          return response.json(); // Antwort in JSON wandeln
        }
      })
      .then(function (data) {
        // data = return vom then davor
        app.log('RETURN', 1);
        app.log(data, 1);
        if (data && data.status === 'OK') {
          if (page === 'hmenuestart' || page === 'hmenueprofil') {
            page = 'start';
          }
          if (!data.store || data.store === '1') {
            var loadedpage = page + (formparam != null ? '?' + formparam : '');
            localStorage.setItem('lastpage', loadedpage);
            app.historyAdd(loadedpage);
          }
          app.updatePage(data);
          localStorage.setItem(
            'ersterstart',
            data.startseq !== 'undefined' ? data.startseq : '1',
          );
          // wenn kein scrolltop und keine formparameter angegeben wurden oder scrolltop=1 dann an den oberen Rand springen.
          if (
            (!data.scrolltop && formparam == null) ||
            data.scrolltop === '1'
          ) {
            $('html,body').scrollTop(0);
          }
          // Wenn Hauptmenü geladen wird, dann auch die Navi
          if (page === 'hmenue' || page === 'start') {
            app.loadNavi();
          }
        } else {
          // Probleme mit der Session oder Token, dann leeren und neu Login
          if (data && data.status === 'ERR') {
            if (data.info) {
              app.spinner.hide();
              alert(data.info);
            }
            if (data.csrfToken) {
              csrfToken = data.csrfToken;
            }
            if (data.loadpage === 'loginform') {
              app.lokalenSpeicherLoeschen();
              top.location.href = location.protocol + '//' + location.hostname; //'https://app.i-gb.de';
            }
          }
        }
      })
      ['catch'](function (reason) {
        app.log(reason, 1);
      });
  };

  app.updatePage = function (obj) {
    if (obj.status === 'OK') {
      if (obj.html) {
        $.each(obj.html, function (tagid, inhalt) {
          $('#' + tagid).html(inhalt);
          if (tagid === 'appModalBody') {
            // wenn appModalBody gesetzt wird, dann Footer auf einfaches Schließsymbol zurück setzen, kann dann durch ein appModalFooter wieder gesetzt werdne
            $('#appModalFooter').html(
              '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>',
            );
          }
        });
      }
      if (obj.input) {
        $.each(obj.input, function (tagid, inhalt) {
          $('#' + tagid).val(inhalt);
        });
      }
      if (obj.select) {
        $.each(obj.select, function (tagid, inhalt) {
          $('#' + tagid).val(inhalt);
        });
      }
      if (obj.prop) {
        $.each(obj.prop, function (tagid, inhalt) {
          $.each(inhalt, function (prop, wert) {
            $('#' + tagid).prop(prop, wert);
          });
        });
      }
      if (obj.removeclass) {
        $.each(obj.removeclass, function (tagid, inhalt) {
          var klassen = inhalt.split(',');
          app.log(klassen, 1);
          $.each(klassen, function (i, k) {
            app.log(i + '::' + k, 1);
            $('#' + tagid).removeClass(k);
          });
        });
      }
      if (obj.addclass) {
        $.each(obj.addclass, function (tagid, inhalt) {
          var klassen = inhalt.split(',');
          app.log(klassen, 1);
          $.each(klassen, function (i, k) {
            app.log(i + '::' + k, 1);
            $('#' + tagid).addClass(k);
          });
        });
      }
      if (obj.jshide) {
        $.each(obj.jshide, function (tagid) {
          $('#' + tagid).hide();
        });
      }
      if (obj.jsshow) {
        $.each(obj.jsshow, function (tagid) {
          $('#' + tagid).show();
        });
      }
      callObjectFunctions(obj)
      if (obj.modal) {
        if (obj.modal === 'show') {
          $('#appModal').modal('show');
        }
        if (obj.modal === 'hide') {
          $('#appModal').modal('hide');
        }
      }
      if (obj.modalnc) {
        if (obj.modalnc === 'show') {
          $('#appModalNC').modal('show');
        }
        if (obj.modalnc === 'hide') {
          $('#appModalNC').modal('hide');
        }
      }
      if (obj.detach) {
        $.each(obj.detach, function (tagid, inhalt) {
          $('#' + tagid).animate({ opacity: 0 }, 500, function () {
            $(this).detach();
          });
        });
      }
      if (obj.highlight) {
        $('#appInfo').html(obj.highlight).fadeIn(); //.effect("highlight", {color: "#ffff99"}, 300);
        setTimeout("$('#appInfo').fadeOut()", 3000);
      }
      if (obj.loadpage) {
        var c = obj.loadpage.indexOf('?');
        app.log(obj.loadpage + c, 1);
        if (c >= 0) {
          var page = obj.loadpage.substr(0, c);
          var formparam = obj.loadpage.substr(c + 1);
          app.loadPage(page, formparam);
        } else {
          app.loadPage(obj.loadpage);
        }
      }
      if (obj.logout && obj.logout === 'logout') {
        app.abmelden();
      }
      if (obj.wartung && obj.wartung === 'wartung') {
        top.location.href = location.protocol + '//' + location.hostname;
      }
      // wenn die Navi getauscht wird, dann click-Handler neu initialisieren
      if (obj.html && obj.html.menu) {
        $('.btnnavi').click(function (event) {
          event.stopPropagation();
          app.loadPage($(this).data('page'));
        });
        $('.btnabmelden').click(function (event) {
          event.stopPropagation();
          app.abmelden();
        });
      }
    }
    app.spinner.hide();
  };

  app.loadNavi = function () {
    //app.log('loadnavi', 1);
    app.loadPage('navi');
    if (localStorage.getItem('ersterstart') === '1') {
      $('#btnmenu').hide();
    } else {
      $('#btnmenu').show();
    }
  };

  app.ladePartnerdetails = function (idPartner, ort) {
    var url = 'api/lesepartnerdetails_nc.php';
    var params = {
      idma: localStorage.getItem('idmitarbeiter'),
      token: localStorage.getItem('apptoken'),
      idp: idPartner,
    };

    if ($('#pd' + idPartner).is(':visible')) {
      if (ort === 'l') {
        $('#pd' + idPartner).hide();
      }
      if (ort === 'k') {
      }
    } else {
      if (ort === 'l') {
        $('.padetails').hide();
      }

      fetch(url, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
          'X-Csrf-Token': csrfToken,
        },
      })
        .then(function (response) {
          if (response.ok) {
            return response.json(); // Antwort in JSON wandeln
          }
        })
        .then(function (data) {
          // data = return vom then davor
          //app.log(data, 1);
          if (data && data.status === 'OK') {
            if (ort === 'l') {
              $('#pd' + idPartner)
                .hide()
                .html(data.html)
                .slideDown();
            }
            if (ort === 'k') {
              app.openModal('', data.html, '');
            }
          } else {
            // TODO
          }
        })
        ['catch'](function (reason) {
          app.log(reason, 1);
        });
    }
  };

  app.ladePartnerangebot = function (idPartner) {
    var url = 'api/lesepartnerangebot_nc.php';
    var params = {
      idma: localStorage.getItem('idmitarbeiter'),
      token: localStorage.getItem('apptoken'),
      idp: idPartner,
    };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
        'X-Csrf-Token': csrfToken,
      },
    })
      .then(function (response) {
        if (response.ok) {
          return response.json(); // Antwort in JSON wandeln
        }
      })
      .then(function (data) {
        // data = return vom then davor
        //app.log(data, 1);
        if (data && data.status === 'OK') {
          $('#pad' + idPartner)
            .hide()
            .html(data.html)
            .slideDown();
        } else {
          // TODO
        }
      })
      ['catch'](function (reason) {
        app.log(reason, 1);
      });
  };

  app.setzeFavoritPartner = function (idPartner, status) {
    var url = 'api/setzefavoritpartner_nc.php';
    var params = {
      idma: localStorage.getItem('idmitarbeiter'),
      token: localStorage.getItem('apptoken'),
      idp: idPartner,
      st: status,
    };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
        'X-Csrf-Token': csrfToken,
      },
    })
      .then(function (response) {
        if (response.ok) {
          return response.json(); // Antwort in JSON wandeln
        }
      })
      .then(function (data) {
        // data = return vom then davor
        //app.log(data, 1);
        if (data && data.status === 'OK') {
          $('#fav' + idPartner).html(data.html);
        } else {
          // TODO
        }
      })
      ['catch'](function (reason) {
        app.log(reason, 1);
      });
  };

  app.setzeFilterPartner = function (filter, status) {
    var url = 'api/setzefilterpartner_nc.php';
    var params = { idf: filter, st: status };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
        'X-Csrf-Token': csrfToken,
      },
    })
      .then(function (response) {
        if (response.ok) {
          return response.json(); // Antwort in JSON wandeln
        }
      })
      .then(function (data) {
        // data = return vom then davor
        //app.log(data, 1);
        if (data && data.status === 'OK') {
          $('.modal-body #filter' + filter).html(data.html);
        } else {
          // TODO
        }
      })
      ['catch'](function (reason) {
        app.log(reason, 1);
      });
  };

  app.lesePlz = function (latitude, longitude) {
    var url = 'api/leseplz_nc.php';
    var params = {
      idma: localStorage.getItem('idmitarbeiter'),
      token: localStorage.getItem('apptoken'),
      a: 'lp',
      lon: longitude,
      lat: latitude,
    };

    localStorage.setItem('latitude', latitude);
    localStorage.setItem('longitude', longitude);

    app.spinner.show();

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
        'X-Csrf-Token': csrfToken,
      },
    })
      .then(function (response) {
        if (response.ok) {
          return response.json(); // Antwort in JSON wandeln
        }
      })
      .then(function (data) {
        // data = return vom then davor
        app.log(data, 1);
        if (data && data.status === 'OK') {
          $('input[name=plz]').val(data.plz);
        } else {
          // TODO
        }
        app.spinner.hide();
      })
      ['catch'](function (reason) {
        app.log(reason, 1);
      });
  };

  app.leseBundeslandZuPlz = function (elementPlz, elementBundesland) {
    var plz = $(elementPlz).val();
    var url = 'api/leseplz_nc.php';
    var params = {
      idma: localStorage.getItem('idmitarbeiter'),
      token: localStorage.getItem('apptoken'),
      a: 'blzplz',
      plz: plz,
    };

    app.spinner.show();

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
        'X-Csrf-Token': csrfToken,
      },
    })
      .then(function (response) {
        if (response.ok) {
          return response.json(); // Antwort in JSON wandeln
        }
      })
      .then(function (data) {
        // data = return vom then davor
        app.log(data, 1);
        if (data && data.status === 'OK') {
          $(elementBundesland).val(data.id);
        } else {
          // TODO
        }
        app.spinner.hide();
      })
      ['catch'](function (reason) {
        app.log(reason, 1);
      });
  };

  app.loadMap = function () {
    var params =
      'ansicht=karte&lat=' +
      localStorage.getItem('latitude') +
      '&lon=' +
      localStorage.getItem('longitude');
    app.loadPage(
      'findepartner_nc',
      $('form[name=eingabe]').serialize() + '&' + params,
    );
  };

  app.loadListe = function () {
    var params = 'ansicht=tab';
    app.loadPage(
      'findepartner_nc',
      $('form[name=eingabe]').serialize() + '&' + params,
    );
  };

  app.showmore = function () {
    $('div.contentMore').each(function () {
      app.log($(this).attr('data-height'), 1);
      $(this)
        .css('height', $(this).attr('data-height'))
        .css('overflow', 'hidden');
    });

    $('.showMoreBtn').on('click', function () {
      var $this = $(this);
      var $content = $this.prev('div.contentMore');
      var linkText = $this.text().toUpperCase();

      if (linkText === 'MEHR') {
        linkText = 'WENIGER';
        $content.css('height', 'auto');
      } else {
        linkText = 'MEHR';
        $content.css('height', $content.attr('data-height'));
      }

      $this.text(linkText);
    });
  };

  app.formatZahl = function (zahl, digits) {
    var pow = Math.pow(10, digits || 5);
    return Math.round(zahl * pow) / pow;
  };

  app.checkPwStrength = function (value) {
    var value = value.trim();
    var weakRegEx = new RegExp('([a-z]{1}[A-Z]{1})|([A-Z]{1}[a-z]{1})[^s]'); // Klein-/Großbuchstaben
    var mediumRegEx = new RegExp('[0-9]{1}'); // Ziffer
    var strongRegEx = new RegExp('[^a-zA-Z0-9]{1}'); // Sonderzeichen
    var anzeige = $('#strengthmeter');
    var pwstaerke = $('#pwstaerke');

    anzeige.show();
    if (
      value.length >= 8 &&
      (weakRegEx.test(value) ||
        mediumRegEx.test(value) ||
        strongRegEx.test(value))
    ) {
      if (
        (mediumRegEx.test(value) && weakRegEx.test(value)) ||
        (strongRegEx.test(value) && weakRegEx.test(value)) ||
        (strongRegEx.test(value) && mediumRegEx.test(value))
      ) {
        if (
          strongRegEx.test(value) &&
          mediumRegEx.test(value) &&
          weakRegEx.test(value)
        ) {
          anzeige.attr('class', 'strong').html('Passwortsicherheit: sehr hoch');
          pwstaerke.val('ok');
        } else {
          anzeige.attr('class', 'good').html('Passwortsicherheit: hoch');
          pwstaerke.val('ok');
        }
      } else {
        anzeige.attr('class', 'weak').html('Passwortsicherheit: niedrig');
        pwstaerke.val('ok');
      }
    } else {
      if (value.length === 0) {
        anzeige.attr('class', '').html('Passwortsicherheit: ');
        pwstaerke.val('');
        anzeige.hide();
      } else {
        anzeige.attr('class', 'poor').html('Passwortsicherheit: ungenügend');
        pwstaerke.val('');
      }
    }
  };

  app.openModal = function (titel, body, footer, modaltyp) {
    if (typeof modaltyp === 'undefined' || modaltyp === '') {
      modaltyp = 'normal';
    }
    if (typeof footer === 'undefined') {
      footer = '';
    }

    var appModal = $('#appModal');
    if (modaltyp === 'noclose') {
      appModal = $('#appModalNC');

      //$('div.modal-content button.close').hide();
      //appModal.data('bs.modal').options.backdrop = 'static';
      ////appModal.off('keydown.dismiss.bs.modal');
      //appModal.data('bs.modal').options.keyboard = false;
      //appModal.off('keydown.dismiss.bs.modal'); // Disable ESC
      $('#appModalNCTitle').html(titel);
      if (body.substr(0, 1) === '#') {
        $('#appModalNCBody').html($(body).html());
      } else {
        $('#appModalNCBody').html(body);
      }
      if (footer === '') {
        $('#appModalNCFooter').html('');
      } else {
        $('#appModalNCFooter').html(footer);
      }
      appModal.modal('show');
    } else {
      //$('div.modal-content button.close').show();
      //appModal.data('bs.modal').options.backdrop = true;
      //appModal.data('bs.modal').options.keyboard = true;
      //appModal.data('bs.modal').escape(); // Resets ESC

      $('#appModalTitle').html(titel);
      if (body.substr(0, 1) === '#') {
        $('#appModalBody').html($(body).html());
      } else {
        $('#appModalBody').html(body);
      }
      if (footer === '') {
        //$('#appModalFooter').html('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>');
        //Kreuz zum schließen unten ist leider nicht mehr Hipp..
        $('#appModalFooter').html('');
      } else {
        $('#appModalFooter').html(footer);
      }

      appModal.modal('show');
    }
  };

  app.closeModal = function (modaltyp) {
    if (typeof modaltyp === 'undefined' || modaltyp === '') {
      modaltyp = 'normal';
    }

    if (modaltyp === 'noclose') {
      $('#appModalNCFooter').html(
        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>',
      );
      $('#appModalNC').modal('hide');
    } else {
      $('#appModalFooter').html(
        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>',
      );
      $('#appModal').modal('hide');
    }
  };

  app.log = function (text, level) {
    if (app.debug >= level) {
      console.log(text);
    }
  };

  // Push Manager Funktionen

  // Prüfen ob PushManager vorhanden ist und benutzt werden kann
  app.pushmanagerCheck = function () {
    if ('PushManager' in window) {
      console.log('PushManager im ServiceWorker wird unterstützt');
      navigator.serviceWorker
        .register('serviceworker.js')
        .then(function (swReg) {
          console.log('Push: ServiceWorker registriert');
          swRegistration = swReg;
          localStorage.setItem('pushsystem', 'web');
          if (app.updatePushPermission() === 1) {
            updateSubscriptionOnServer(subscription);
          }
        })
        ['catch'](function (error) {
          console.log(
            'Push: ServiceWorker nicht registriert. Fehler: ' + error,
          );
        });
    }
    // OSX Safari
    else if ('safari' in window && 'pushNotification' in window.safari) {
      localStorage.setItem('pushsystem', 'osx');
      app.updatePushPermission();
    }
    // Push nicht möglich
    else {
      console.warn('Push Mitteilungen werden nicht unterstützt.');
      localStorage.setItem('pushsystem', '');
      localStorage.setItem('pushnotification', -1);
    }
  };

  // Status der Push-Mitteilung prüfen und speichern für Web-Push und Safari OSX
  app.updatePushPermission = function () {
    app.log(swRegistration, 1);
    if (
      localStorage.getItem('pushsystem') === 'web' &&
      swRegistration !== null
    ) {
      //if (Notification.permission === 'denied') {
      //    localStorage.setItem('pushnotification', -1);
      //}
      swRegistration.pushManager
        .getSubscription()
        .then(function (subscription) {
          if (!(subscription === null)) {
            app.log('Push (Web) aktiviert', 1);
            localStorage.setItem('pushnotification', 1);
            if (pushCallback !== null && pushCallback !== '') {
              pushCallback();
            }
            return 1;
          } else {
            if (Notification.permission === 'denied') {
              app.log('Push (Web) blockiert', 1);
              localStorage.setItem('pushnotification', 2);
              return 0;
            } else {
              app.log('Push (Web) deaktiviert', 1);
              localStorage.setItem('pushnotification', 0);
              if (pushCallback !== null && pushCallback !== '') {
                pushCallback();
              }
              return 0;
            }
          }
        })
        ['catch'](function (error) {
          app.log('Error updatesubscription' + error, 1);
          return -1;
        });
    } else if (
      localStorage.getItem('pushsystem') === 'osx' &&
      'safari' in window &&
      'pushNotification' in window.safari
    ) {
      var permissionData = window.safari.pushNotification.permission(
        app.iososxWebsitePushId,
      );
      app.log(permissionData, 1);
      if (permissionData.permission === 'granted') {
        app.log('Push (OSX) aktiviert', 1);
        localStorage.setItem('pushnotification', 1);
        if (pushCallback !== null && pushCallback !== '') {
          pushCallback();
        }
        return 1;
      } else {
        // denied
        app.log('Push (OSX) deaktiviert', 1);
        localStorage.setItem('pushnotification', 0);
        if (pushCallback !== null && pushCallback !== '') {
          pushCallback();
        }
        return 0;
      }
    } else {
      if (pushCallback !== null && pushCallback !== '') {
        pushCallback();
      }
      return -1;
    }
  };

  app.checkPushPermission = function () {
    return localStorage.getItem('pushnotification');
  };

  app.getPushSystem = function () {
    return localStorage.getItem('pushsystem');
  };

  // Push-Mitteilung anlegen für Web-Push und Safari OSX
  app.subscribeUser = function (callback) {
    pushCallback = callback;

    // Web-Push android, Firefo, Chrome usw.
    if (
      localStorage.getItem('pushsystem') === 'web' &&
      swRegistration !== null
    ) {
      const applicationServerKey = urlB64ToUint8Array(
        applicationServerPublicKey,
      );
      app.log('web: Subscribe aufgerufen', 1);
      Notification.requestPermission()
        .then(function (result) {
          if (result === 'denied') {
            app.log("Permission wasn't granted. Allow a retry.", 1);
            localStorage.setItem('pushnotification', 3);
            document.location.reload();
          }
          if (result === 'default') {
            app.log('The permission request was dismissed.', 1);
            updateSubscriptionOnServer(subscription);
          }
          swRegistration.pushManager
            .subscribe({
              userVisibleOnly: true,
              applicationServerKey: applicationServerKey,
            })
            .then(function (subscription) {
              app.log('Push wurde aktiviert', 1);
              updateSubscriptionOnServer(subscription);
            })
            ['catch'](function (err) {
              app.log('Failed to subscribe the user: ' + err, 1);
              localStorage.setItem('pushnotification', 3);
              document.location.reload();
            });
        })
        ['catch'](function (err) {
          app.log('Failed to subscribe the user: ' + err, 1);
          localStorage.setItem('pushnotification', 3);
          document.location.reload();
        });
    }

    // Safari OSX
    if (
      localStorage.getItem('pushsystem') === 'osx' &&
      'safari' in window &&
      'pushNotification' in window.safari
    ) {
      app.log('osx: Subscribe aufgerufen', 1);
      var permissionData = window.safari.pushNotification.permission(
        app.iososxWebsitePushId,
      );
      if (permissionData.permission === 'default') {
        app.log('osx: Permission default', 1);
        // This is a new web service URL and its validity is unknown.
        window.safari.pushNotification.requestPermission(
          location.protocol + '//' + location.hostname + '/push.php', // The web service URL.
          app.iososxWebsitePushId, // The Website Push ID.
          { id: localStorage.getItem('idmitarbeiter') }, // Data that you choose to send to your server to help you identify the user.
          app.osxCheckRemotePermission, // The callback function.
        );
      }
    }
  };

  // Push Mitteilung entfernen für Web-Push
  app.unsubscribeUser = function (callback) {
    pushCallback = callback;
    if (
      localStorage.getItem('pushsystem') === 'web' &&
      swRegistration !== null
    ) {
      app.log('Unsubscribe aufgerufen', 1);
      swRegistration.pushManager
        .getSubscription()
        .then(function (subscription) {
          if (subscription) {
            return subscription.unsubscribe();
          }
        })
        ['catch'](function (error) {
          app.log('Error unsubscribing' + error, 1);
        })
        .then(function () {
          updateSubscriptionOnServer(null);
          app.log('Push wurde deaktiviert', 1);
        });
    }
    //if (localStorage.getItem('pushsystem') === 'osx' && 'safari' in window && 'pushNotification' in window.safari) {
    //    app.osxCheckRemotePermission(callback);
    //}
  };

  // Push-Mitteilung auf Server aktualisieren für Web-Push
  function updateSubscriptionOnServer(subscription) {
    var idma = localStorage.getItem('idmitarbeiter');
    var token = localStorage.getItem('apptoken');
    var SERVER_URL = 'push.php';

    if (subscription) {
      // Subscription hinzufügen
      subscription = { subscription: subscription, idma: idma, token: token };
      // saveSubscription saves the subscription to the backend
      fetch(SERVER_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
          'X-Csrf-Token': csrfToken,
        },
        body: JSON.stringify(subscription),
      })
        .then(function (response) {
          if (response.ok) {
            app.log('Response OK', 2);
            app.updatePushPermission();
          }
        })
        ['catch'](function (error) {
          app.log('Error updatesubscription' + error, 1);
          app.updatePushPermission();
        });
    } else {
      // Subscription entfernen
      subscription = { subscription: subscription, idma: idma, token: token };
      //subscriptionDetails.classList.add('is-invisible');
      // saveSubscription saves the subscription to the backend
      fetch(SERVER_URL, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(subscription),
      })
        .then(function (response) {
          if (response.ok) {
            app.log('Response OK', 2);
            app.updatePushPermission();
          }
        })
        ['catch'](function (error) {
          app.log('Error updatesubscription' + error, 1);
          app.updatePushPermission();
        });
    }
  }

  app.osxCheckRemotePermission = function () {
    app.log('osx: Check remote permission', 1);
    app.updatePushPermission();
  };

  // Url-Args in Object wandeln: ?page=test&id=1234 => {"page": "test","id":"1234"}
  app.urlargs2Object = function (urlargs) {
    var args = urlargs
      .toString()
      .replace(/^.*?\?/, '')
      .replace(/#[.*]$/, '')
      .split('&');
    var urlparams = {};
    for (var i = 0, l = args.length; i < l; i++) {
      var aux = decodeURIComponent(args[i]).split('=');
      urlparams[aux[0]] = aux[1].trim();
    }

    return urlparams;
  };

  // Url Params auswerten
  app.urlparamsAuswerten = function (urlparams) {
    if (typeof urlparams['p'] !== 'undefined') {
      app.log('loadPage postfachdetail id=' + urlparams['p'], 1);
      app.loadPage('postfachdetail', 'id=' + urlparams['p'] + '&t=B');
    }
    if (typeof urlparams['vp'] !== 'undefined') {
      var formparam = '';
      if (Object.keys(urlparams).length > 1) {
        $.each(urlparams, function (key, val) {
          if (key !== 'vp') {
            if (formparam !== '') {
              formparam += '&';
            }
            formparam += key + '=' + val;
          }
        });
      }
      app.log('loadPage ' + urlparams['vp'] + ' und Parameter ' + formparam, 1);
      app.loadPage(urlparams['vp'], formparam);
    }
  };

  // Serviceworker registrieren
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('serviceworker.js', { scope: './' })
      .then(function (reg) {
        // registration worked
        console.log('ServiceWorker registriert. Scope: ' + reg.scope);
      })
      ['catch'](function (error) {
        // registration failed
        console.log('ServiceWorker nicht registriert. Fehler: ' + error);
      });

    app.pushmanagerCheck();
  } else {
    console.warn('Serviceworker werden nicht unterstützt.');
  }

  // Get-Variablen lesen
  var GET = {};
  if (document.location.toString().indexOf('?') !== -1) {
    var query = document.location
      .toString()
      // get the query string
      .replace(/^.*?\?/, '')
      // and remove any existing hash string (thanks, @vrijdenker)
      .replace(/#[.*]$/, '')
      .split('&');

    for (var i = 0, l = query.length; i < l; i++) {
      var aux = decodeURIComponent(query[i]).split('=');
      GET[aux[0]] = aux[1];
    }
  }

  app.init();

  function urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  /*function updateBtn() {
        if (Notification.permission === 'denied') {
            //pushButton.textContent = 'Push Messaging Blocked.';
            localStorage.setItem('pushnotification', -1);
            //pushButton.disabled = true;
            //updateSubscriptionOnServer(null);
        }
        //pushButton.disabled = false;
    }*/

  /*function initializePush() {
        // Set the initial subscription value
        swRegistration.pushManager.getSubscription().then(function (subscription) {
            isSubscribed = !(subscription === null);
            if (isSubscribed) {
                app.log('User IS subscribed', 1);
                updateSubscriptionOnServer(subscription);
            } else {
                app.log('User is NOT subscribed', 1);
            }
            updateBtn();
        })['catch'](function (error) {
            app.log('Error updatesubscription' + error, 1);
        });
    }*/

  function storageAvailable(type) {
    try {
      var storage = window[type],
        x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage.length !== 0
      );
    }
  }

  window.app = app;
})();
